import {
  requiredEmailValidator,
  requiredPhoneNumberValidator,
  requiredCountryValidator,
  emailValidator,
  requiredOnlyDigtsNotAllowedValidator,
} from '../components/Forms/validators'

export const BusinessApplicationForm = {
  model: 'Business',
  format: [
    {
      header: 'Business Information',
      fields: {},
    },
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          label: 'Legal Business Name',
          validator: (input) => {
            return requiredOnlyDigtsNotAllowedValidator(input, 'business name')
          },
        },
        referral: {
          type: 'text',
          label: 'Referral',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        contact_first_name: {
          required: true,
          type: 'text',
          label: 'Contact First Name',
          validator: (input) => {
            return requiredOnlyDigtsNotAllowedValidator(
              input,
              'contact first name'
            )
          },
        },
        contact_last_name: {
          required: true,
          type: 'text',
          label: 'Contact Last Name',
          validator: (input) => {
            return requiredOnlyDigtsNotAllowedValidator(
              input,
              'contact last name'
            )
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        contact_email: {
          required: true,
          type: 'text',
          label: 'Email',
          validator: (input) => {
            return requiredEmailValidator(input)
          },
        },
        finance_contact_email: {
          required: true,
          type: 'text',
          label: 'Finance Contact Email',
          validator: (input) => {
            return emailValidator(input)
          },
        },
        contact_phone: {
          required: true,
          type: 'phone',
          label: 'Phone',
          validator: (input) => {
            return requiredPhoneNumberValidator(input)
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        type_of_business: {
          required: true,
          type: 'dropdown',
          label: 'Type of Business',
        },
        business_url: {
          required: true,
          type: 'text',
          label: 'Business URL',
        },
        business_tax_id: {
          required: true,
          type: 'text',
          label: 'Tax ID (EIN or Equivalent)',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        credit_extension_requested_in_dollars: {
          required: true,
          type: 'text',
          label: 'Credit Extension Requested ($)',
        },
        nature_of_business: {
          required: true,
          type: 'text',
          label: 'Nature of Business',
        },
        year_started: {
          required: true,
          type: 'text',
          label: 'Year Started',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        primary_business: {
          type: 'dropdown',
          visibleto: ['admin', 'supplier', 'buyer'],
        },
      },
    },
    {
      header: 'Billing Address',
      fields: {},
    },
    {
      widths: 'equal',
      fields: {
        billing_address_line_1: {
          required: true,
          type: 'text',
          label: 'Address 1',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        billing_address_line_2: {
          type: 'text',
          label: 'Address Line Two',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        billing_address_country_code: {
          label: 'Country',
          required: true,
          type: 'country',
          validator: (input) => {
            return requiredCountryValidator(input)
          },
        },
        billing_address_state: {
          label: 'State',
          required: true,
          type: 'dropdown search',
          url: '/main/states/',
          require_params: true,
          related_params: {
            billing_address_country_code: 'country',
          },
          title_fields: ['name'],
          description_fields: [''],
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        billing_address_city: {
          required: true,
          type: 'text',
          label: 'City',
        },
        billing_address_zip_code: {
          required: true,
          type: 'text',
          label: 'Zip Code',
        },
      },
    },
    {
      header: 'Bank Reference',
      fields: {},
    },
    {
      widths: 'equal',
      fields: {
        bank_reference_name: {
          type: 'text',
          label: 'Bank Name',
          required: true,
        },
        bank_reference_branch: {
          type: 'text',
          label: 'Branch Name',
          required: true,
        },
        bank_reference_telephone: {
          type: 'text',
          label: 'Phone Number',
          required: true,
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        bank_reference_loan_officer: {
          type: 'text',
          label: 'Loan Officer',
          required: true,
        },
        bank_reference_checking_account_number: {
          type: 'text',
          label: 'Checking Account Number',
          required: true,
        },
        bank_reference_loan_account_number: {
          type: 'text',
          label: 'Loan Account Number',
          required: true,
        },
      },
    },
  ],
}
